import { GanttZoomLevel } from "../models";

const LABELS: Record<GanttZoomLevel, string> = {
  week: "Week",
  month: "Month",
  quarter: "Quarter",
  year: "Year",
  "1w": "1w",
  "2w": "2w",
  "1m": "1m",
  "3m": "3m",
  "6m": "6m",
  "1y": "1y",
  "5y": "5y",
  "10y": "10y",
  "20y": "20y",
};

const toOptions = (keys: GanttZoomLevel[]): { key: GanttZoomLevel; label: string }[] =>
  keys.map((key) => ({ key, label: LABELS[key] }));

// Roadmaps and tasks share the window-based scale (the label is the span that fits the viewport) —
// roadmaps run 3 months → 20 years, tasks 1 week → 1 year. Both roadmap modes offer the same set:
// project (phase) and deal (stage) roadmaps are read side by side and span comparable horizons.
export const ROADMAP_ZOOMS = toOptions(["3m", "6m", "1y", "5y", "10y", "20y"]);
export const TASKS_ZOOMS = toOptions(["1w", "2w", "1m", "3m", "6m", "1y"]);
